<template>
<div>
    <h1>Create a Playlist ?</h1>
    <el-button style="margin-bottom: 35px;" plain type='warning' @click="continueWithoutPlaylist()">Continue without creating playlist</el-button>

    <el-table ref="fileTable" :data="files" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="entityName" label="Uploaded Asset" show-overflow-tooltip>
            <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">{{scope.row.name}}
                    <p slot="reference">{{ scope.row.entityName }}</p>
                </el-popover>
            </template>
        </el-table-column>
        <el-table-column label="Meta" width="180">
            <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                    <el-tag class="meta-tag" size="small">{{ scope.row.task }}</el-tag>
                    <el-tag class="meta-tag" v-if="scope.row.descriptor" size="small">{{ scope.row.descriptor }}</el-tag>
                    <el-tag class="meta-tag" size="small">{{ scope.row.version }}</el-tag>
                </div>
            </template>
        </el-table-column>
    </el-table>

    <div style="margin-top: 40px;">
        <el-input placeholder="Playlist Name" v-model="playlistName">
            <i class="el-icon-edit el-input__icon" slot="suffix" ></i>
        </el-input>
    </div>
    <el-button style="margin-top: 10px" plain type="success" :disabled="multipleSelection.length==0" @click="continueWithPlaylist()">Create Playlist</el-button>
</div>
</template>

<script>
const moment = require("moment");
import { createPlaylist } from "@/api";

export default {
  props: {
    files: Array
  },
  data() {
    return {
      multipleSelection: [],
      playlistName: null
    };
  },
  computed: {
    versions() {
      return this.files.map(element => element.versionData);
    }
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    continueWithoutPlaylist() {
      this.$eventBus.$emit("submission-done");
    },
    continueWithPlaylist() {
      createPlaylist(this.versions, this.playlistName)
        .then(res => {
          this.$eventBus.$emit("submission-done", res);
        })
        .catch(error => {
          this.$alert(
            "Something went wrong. Playlist creation failed. " + error,
            "Error"
          );
        });
    }
  },

  mounted() {
    this.$refs.fileTable.toggleAllSelection();
    //Date | Submitter | Asset Name | Task | Topic
    const date = moment().format("YYMMDD");
    if (this.files.length > 0) {
      const firstFile = this.files[0];
      this.playlistName = [
        date,
        "Submitter",
        firstFile.entityName,
        firstFile.task,
        "Topic"
      ].join(" | ");
    }
  }
};
</script>

<style scoped>
.meta-tag {
  margin-right: 5px;
}
</style>
